// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"a02dd2f3","718":"e5c9097e"}[chunkId] + ".chunk.css";
};